import React from 'react';
import Autocomplete from 'react-google-autocomplete';
import { injectIntl } from 'react-intl'

const Footer = (props) => {
   
   const intl = props.intl;

   const placeholder1 = intl.formatMessage({
      id: "footer.placeholder"
   });
   
   return (
      <footer className="footer container-fluid">
         <form action="/busca" class="search-form" method="get">
            <div class="col-md-12">
               <div class="input-group input-group-md">
                  <span class="input-group-addon"><span class="fa fa-search"></span></span>
                  <input type="text" class="form-control" placeholder={placeholder1} name="city" autocomplete="on" />
               </div>
            </div>
         </form>
      </footer>
   )
}

export default injectIntl(Footer);
